export var NON_DROPDOWN_TOURNAMENTS_COUNT = 4;
